module.exports = __webpack_public_path__ + "static/media/direction.b8d3aa36.svg";